import React from 'react'
import { useParams } from 'react-router-dom'

import CaseWorkspace from './CaseWorkspace'

/**
 * Case view for a sample id (GEN-5569 extracted the shared body into
 * CaseWorkspace). Behaves exactly as before: reads the :caseId route param and
 * renders the workspace in case mode against the /samples and /cases endpoints,
 * with the family toggle and the single-variant deep-link lookup.
 */
const CasePage: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>()
  const displayId = caseId ? decodeURIComponent(caseId) : ''

  return (
    <CaseWorkspace
      displayId={displayId}
      kind="case"
      // basePath undefined -> the variant hooks default to /cases/{id}.
      tracksPath={`/samples/${encodeURIComponent(displayId)}/tracks`}
      variantLookupPath={(variantId, track) => {
        const trackQuery = track ? `&track=${encodeURIComponent(track)}` : ''
        return `/variants/${encodeURIComponent(variantId)}?sample_id=${encodeURIComponent(displayId)}${trackQuery}`
      }}
      backTo="/home"
      backLabel="Back to Home"
      titleKicker="Case"
    />
  )
}

export default CasePage
